import api from "../../app/api";
import { TRANSACTIONS_TIMEOUT } from "../../utils/const";

export const getTransactionsFiltered = async (data) => {
  const response = await api.post(`nucleus/tnx/paginated/filter`, data, { timeout: TRANSACTIONS_TIMEOUT });
  return response.data;
};

export const getTransactionsAll = async (data) => {
  const response = await api.post(`nucleus/tnx/paginated/filter`, data, { timeout: TRANSACTIONS_TIMEOUT });
  return response.data;
};
